import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalsService } from './globals.service';

export interface HelpPayload {
  company: string;
  email: string;
  fullName: string;
  products: string[];
}

@Injectable({
  providedIn: 'root',
})
export class HelpCenterService {
  coreAPI: string = '';

  constructor(
    private http: HttpClient,
    private globals: GlobalsService
  ) {
    this.coreAPI = this.globals.coreAPI;
  }

  generateHelpToken(request: HelpPayload) {
    return this.http.post(`${this.coreAPI}core/help/generate-help-url`, request);
  }
}
